import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10">
      <div className="px-5 pb-10 pt-16 md:px-16 md:pt-24">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <nav className="flex flex-col gap-3" aria-label="Footer">
            <Link to="/work" data-testid="footer-work-link" className="w-fit text-sm text-fog transition-colors duration-300 hover:text-white">
              Work
            </Link>
            <Link to="/custom" data-testid="footer-custom-link" className="w-fit text-sm text-fog transition-colors duration-300 hover:text-white">
              Custom
            </Link>
            <Link to="/start" data-testid="footer-start-link" className="w-fit text-sm text-fog transition-colors duration-300 hover:text-white">
              Start a Project
            </Link>
          </nav>
          <p className="max-w-xs text-xs leading-relaxed text-fog/70">
            Tell us what you&rsquo;re working on — a few quick questions is all it takes to
            start.
          </p>
        </div>

        <motion.p
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, ease: EASE }}
          aria-hidden="true"
          className="mt-16 select-none whitespace-nowrap font-display text-[14.5vw] font-semibold leading-[0.8] tracking-[-0.04em] text-outline md:mt-20"
        >
          FINDLEY ST
        </motion.p>

        <div className="mt-8 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-6">
          <p className="text-[10px] uppercase tracking-[0.3em] text-fog/60">
            © {new Date().getFullYear()} Findley St Media
          </p>
          <nav className="flex items-center gap-6" aria-label="Legal">
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-[10px] uppercase tracking-[0.3em] text-fog/60 transition-colors duration-300 hover:text-white">
              Privacy
            </Link>
            <Link to="/terms" data-testid="footer-terms-link" className="text-[10px] uppercase tracking-[0.3em] text-fog/60 transition-colors duration-300 hover:text-white">
              Terms
            </Link>
          </nav>
          <p className="text-[10px] uppercase tracking-[0.3em] text-fog/60">
            Web design &amp; development studio
          </p>
        </div>
      </div>
    </footer>
  );
}
